/* ════ STATE ═══════════════════════════════════════════════ */
// Shared mutable application state. Modules mutate fields on this object
// (rather than reassigning module-level `let` bindings, which cannot cross
// ES module boundaries).
export const state = {
  resources: [], tasks: [], ideas: [], trips: [], categories: [],
  editTripId: null, settings: {}, co2Year: new Date().getFullYear(), tripIgnores: new Set(), co2Modes: null,
  leaveAllowances: [], leaveRequests: [], absences: [], hrKeys: [], recordEmail: null, leaveTab: 'requests', leaveYear: new Date().getFullYear(),
  editId: null, editIdeaId: null,
  selCat: 'output', selIdeaCat: 'output', selSnap: 'full',
  selImp: 'normal', selIdeaImp: 'normal',
  subtasks: [], ideaSubtasks: [],
  taskTags: [], ideaTags: [], ideaMentions: [],
  inboxSort: 'newest', inboxTag: 'all', inboxDue: 'all', inboxUser: '', users: [], activity: [],
  currentUser: null, mcYear: new Date().getFullYear(),
  // Default to the 2-week view, opening ~5 days before today (today sits a few
  // days in from the left).
  viewStart: (() => { const d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() - 5); return d; })(),
  viewDays: 14, DAY_W: 34, LANE_H: 48,
  drawState: null, currentView: 'gantt', skipWeekends: false,
  // Planner / list filters.
  filters: { cat: 'all', resource: 'all', role: 'all', importance: 'all', text: '', client: 'all', team: 'all', invoicing: 'all', hideDone: false },
  historySearch: '',
};
